import { useMemo } from "react";

import { BucketOfLearninRow } from "./BucketOfLearninRow";
import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";

const getQuestPathId = quest => quest.paths?.slice(-1)[0]?.id ?? quest.role?.id;

export const QuestBucket = ({ currentQuests = [] }) => {
  const { quests, isLoading } = useLevelContext();

  const notEnrolledQuests = useMemo(() => {
    const enrolledRoleIds = new Set(currentQuests.map(q => q.id));

    return quests
      .map(quest => {
        const questPathId = getQuestPathId(quest);
        if (questPathId == null || enrolledRoleIds.has(questPathId)) return null;

        return {
          ...quest,
          id: questPathId,
        };
      })
      .filter(Boolean);
  }, [quests, currentQuests]);

  // viewAllHref is ignored by the legacy row when the upgraded UX flag is off.
  return (
    <div className="my-8">
      <BucketOfLearninRow
        key="quest-row"
        id="quest"
        name="Quests"
        variant="indigo"
        loading={isLoading}
        learnins={notEnrolledQuests}
        pathType="Quest"
        viewAllHref="/quests"
      />
    </div>
  );
};
